import { Col, Row } from "react-bootstrap";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../shared/oversight-core/ui-elements/modal-container/modal-container";

const SystemPurchaseModal = (props: ModelContainerProps) => {
  const { show, onClose, onConfirm } = props;

  return (
    <ModalContainer
      show={show}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={onConfirm}
      confirmButtonText="Login & Purchase"
      title="Purchase Your System"
    >
      <Row>
        <Col className="text-color-2">
          Login and purchase the system? To purchase the system you must be
          logged in to the system.
        </Col>
      </Row>
    </ModalContainer>
  );
};

export default SystemPurchaseModal;
